/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/
import { lazy } from "react";

export default {
	'frozen-columns-onboarding': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--frozen-columns-onboarding/placements/in-app/screen-space-flags/render'
			),
	),
	'jira-nin-group-by-any-field-changeboarding': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--jira-nin-group-by-any-field-changeboarding/placements/in-app/screen-space-flags/render'
			),
	),
	'jira-timeline-10k-issues-message': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--jira-timeline-10k-issues-message/placements/in-app/screen-space-flags/render'
			),
	),
	'jira-timeline-feedback-collector-changeboarding': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--jira-timeline-feedback-collector-changeboarding/placements/in-app/screen-space-flags/render'
			),
	),
};
